import React from "react";
import { useTranslation } from "react-i18next";
import Field from "./field";
import { Profile } from "../../../types/types";
import { formatWordArray } from "../../../utils/formatUtils";

interface FighterDetailsProps {
    member: Profile;
}

const FighterDetails: React.FC<FighterDetailsProps> = ({ member }) => {
    const { t } = useTranslation('publicProfile');
    if (!member.fighter) return null;

    return (
        <div className="space-y-6 pb-8 text-start">
            <h3 className="text-base font-semibold text-gray-800 border-b pb-2">
                {t("fighter_details")}
            </h3>
            <div className="grid grid-cols-3 gap-4">
                <Field label="nickname" value={member.fighter.nickname} />
                <Field
                    label="date_of_birth"
                    value={
                        member.fighter.dateOfBirth
                            ? new Date(member.fighter.dateOfBirth).toLocaleDateString()
                            : "N/A"
                    }
                />
                <Field label="stance" value={member.fighter.stance} />
                <Field
                    label="height"
                    value={`${member.fighter.height} ${member.fighter.heightUnit}`}
                />
                <Field
                    label="weight"
                    value={`${member.fighter.weight} ${member.fighter.weightUnit}`}
                />
                <Field
                    label="reach"
                    value={`${member.fighter.reach} ${member.fighter.reachUnit}`}
                />
                <Field label="team" value={member.fighter.team} />
                <Field label="gym" value={member.fighter.gym} />
                <Field
                    label="title_holder"
                    value={member.fighter.titleHolder ? "Yes" : "No"}
                />
            </div>
            <Field
                label="training_disciplines"
                value={formatWordArray(member.fighter.trainingDisciplines)}
            />
            <Field
                label="weight_classes"
                value={member.fighter.weightClasses?.join(", ")}
            />
            <Field
                label="fight_style_description"
                value={member.fighter.fightStyleDescription}
            />
        </div>
    );
};

export default FighterDetails;
